import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import GatewayListCard from '../Card/GatewayListCard';
function GatewayListView(props) {
    return props.userCustomers ? _jsx(GatewayListCard, { ...props }) : _jsx(_Fragment, {});
}
export default GatewayListView;
